import { MODE } from '../../../data/queryFactories'
import AccountGuestForm from '../../../features/account-management/account-guest/AccountGuestForm'
import { useNav } from '../../../hooks/useNav'
import { accountService } from '../../../service/AccountService'
import { PATH } from '../../../data/router_path'
import { accountGroupUsers } from '../../../service/AccountGroupUsers'
export default function CreateGuestAccountPage() {
  const navigate = useNav()

  const handleSubmit = async (formData) => {
    const groupsId = formData.groups
    const dataCreateAccount = Object.fromEntries(
      Object.entries(formData).filter(([item]) => item !== 'groups')
    )
    try {
      const resCreateAccount =
        await accountService.createAccountGuest(dataCreateAccount)

      if (resCreateAccount?.status === 201) {
        for (const groupId of groupsId) {
          const payload = {
            userUuids: [resCreateAccount?.data?.data?.uuid],
            groupUuid: groupId,
          }
          try {
            const addGroupToAccountCreated =
              await accountGroupUsers.addListUserToGroup(payload)
            navigate(PATH.ACCOUNT.GUEST.LIST)
            window.location.reload()
            if (!addGroupToAccountCreated.success)
              throw new Error('Lỗi khi thêm nhóm tài khoản!')
            navigate(PATH.ACCOUNT.GUEST.LIST)
          } catch (error) {
            throw new Error(
              error.message || 'Lỗi không thêm được nhóm tài khoản!'
            )
          }
        }
      }
    } catch (error) {
      throw new Error(error.message || 'Lỗi không tạo được tài khoản!')
    }
  }
  return (
    <AccountGuestForm
      mode={MODE.CREATE}
      initForm={{}}
      submitHandler={handleSubmit}
    />
  )
}
